import { mapToFrontPlatform } from 'utils';
import { isArray, isObject } from 'lib';
import { contentAdapter } from 'store/content/adapters';
import {
  reorderPlatforms,
  transformAdvancedFilters,
} from './autoBulletin.helpers';
import { autoBulletinFiltersInitialState } from './initialState/autoBulletin.initialState';

export const autoBulletinAdapter = (item) => {
  const params = JSON.parse(
    item.params && item.params !== 'null' ? item?.params : '[]'
  );

  const advancedFilters = { ...autoBulletinFiltersInitialState };

  if (isObject(params)) {
    Object.entries(params)?.map(([key, value]) => {
      const platform = mapToFrontPlatform[key];

      advancedFilters[platform] = transformAdvancedFilters(value, platform);
    });
  }

  const configs = JSON.parse(item.configs || '[]');

  const platforms = [],
    selectedSort = {};
  reorderPlatforms(Object.keys(params)).forEach((apiPlatform) => {
    const platform = mapToFrontPlatform[apiPlatform];
    platforms.push(platform);
    selectedSort[platform] = params[platform]?.sort || 'time';
  });

  return {
    id: item.id,
    title: item.title,
    suffixType: item.suffix_type,
    creationHour: item.creation_hour,
    updatedAt: item.updated_at,
    highlightWords: configs?.highlightWords,
    active: item.active,
    days: item.days,
    hash: item.hash,
    internalBulletinsCount:
      item?.internal_bulletins_count || item?.last_number || 0,
    platforms: platforms,
    lastBulletinId: item?.last_bulletin?.id ?? null,
    params: params,
    isOwner: item.is_owner,
    bulletin: {
      id: item?.with_bulletin?.id,
      createdAt: item?.with_bulletin?.created_at,
    },
    summery: item.want_summary,
    selectedSort,
    advancedFilters,
    primaryColor: item?.primary_color,
    secondaryColor: item?.secondary_color,
    logo: item?.logo,
    headerType: item?.header_type,
    enableLogo: item?.enable_logo,
  };
};

export const archiveAdapter = (archive) => {
  return {
    id: archive.id,
    createdAt: archive.created_at,
  };
};

export const allContentsAdapter = (response) => {
  const { data, meta } = response.data?.result;
  const {
    sorts,
    summary = null,
    bulletin_summary_content_total_count = 0,
    ...apiPlatforms
  } = data;

  const allContents = {};
  const allPinnedContents = {};

  for (const apiPlatform in apiPlatforms) {
    const platform = mapToFrontPlatform[apiPlatform];
    allContents[platform] = {};
    allPinnedContents[platform] = {};
    if (isArray(data[apiPlatform])) {
      allContents[platform].data = data[apiPlatform].map((content) =>
        contentAdapter(content, platform)
      );
    }
    allContents[platform].total = meta[apiPlatform];
    allPinnedContents[platform] =
      sorts?.[apiPlatform]?.current_sort === 'manual'
        ? sorts?.[apiPlatform]?.ids
        : [];
  }

  return {
    allContents,
    allPinnedContents,
    summary,
    summeryContentCount: bulletin_summary_content_total_count,
  };
};

export const webBulletinAdapter = (item) => {
  return {
    id: item.id,
    title: item.title,
    bulletin: {
      createdAt: item.created_at,
    },
  };
};

export const bulletinWebPlatformAdapter = (data) => {
  const platforms = [];
  reorderPlatforms(Object.keys(data)).forEach((platform) => {
    platforms.push({
      platform: mapToFrontPlatform[platform],
      count: data[platform],
    });
  });

  return platforms;
};
